import { render, staticRenderFns } from "./course_comment_each.vue?vue&type=template&id=fffc4f90&scoped=true&"
import script from "./course_comment_each.vue?vue&type=script&lang=js&"
export * from "./course_comment_each.vue?vue&type=script&lang=js&"
import style0 from "./course_comment_each.vue?vue&type=style&index=0&id=fffc4f90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffc4f90",
  null
  
)

export default component.exports